import { useState } from "react";
import "./ExpenseForm.css";

const ExpenseForm=(props)=>{
    const [title,changeTitle]=useState("");
    const [amount,changeAmount]=useState("");
    const [date,changeDate]=useState("");

    const titlechange=(event)=>{
        changeTitle(event.target.value);
    }
    const amountchange=(event)=>{
        changeAmount(event.target.value);
    }
    const datechange=(event)=>{
        changeDate(event.target.value);
    }

    const submitHandler=(event)=>{ // on clicking submit the form, we are creating the 
        // form object, with title price and date, and clearing out the inputs for further
        // addition.
        event.preventDefault(); // stopping the page from reloading
        const formdata={
            title: title,
            price: amount,
            date: new Date(date)
        };
        changeTitle("");
        changeAmount("");
        changeDate("");
        props.onExpenseSubmit(formdata); // calling the parent function with new formdata.
    }

    // const soundPlay=()=>{
    //     let audio=new Audio("mixkit-magical-coin-win-1936.mp3");
    //     audio.play();
    // }

    const changeActive=()=>{ // when clicking the cancel button, cancelling the addition
        // by toggling the active state present in NewExpense.
        props.active();
    }

    return (
        <form onSubmit={submitHandler}>
            <div className="formcontainer">
                <div className="inputfields">
                    <label>Title</label>
                    <input type="text" value={title} onChange={titlechange}/>
                </div>
                <div>
                    <label>Amount</label>
                    <input type="number" min="1" max="2000000" value={amount} onChange={amountchange}/>
                </div>
                <div>
                    <label>Date</label>
                    <input type="date" min="2019-01-01" max="2024-01-01" value={date} onChange={datechange}/>
                </div>
            </div>
            <div>
                <button className="btn" onClick={changeActive}>Cancel</button>
                <button className="btn">Add Expense</button>
            </div>
        </form>
    );
}

export default ExpenseForm;